/** This files contains the methods */

import {
  CLEAR_ERROR,
  CONVERSATION_SELECTED,
  SET_ERROR,
  UPDATE_CONVERSATION_LOG,
  STATUS_CODE,
  USER_NAME,
  CLIENT_MESSAGE_FUNC,
  OPERATOR_WATCHLIST,
  CENTER_STATUS_LIST,
  CALL_TAKEN,
  CENTER_LIST,
  STATUS_LIST,
  CENTER_LIST_CALLHISTORY,
  STATUS_LIST_CALLHISTORY,
  SUCCESS_CALL_STATUS,
  CALL_RECORD,
  CNETR_NAME,
  CENTER_PREFIX,
  CALL_SOURCE,
  MOBILE_NUMBER,
  RESPONSE_OF_CALL,
  CLEAR_CONVERSATION_ID,
  DATA_CAME_FROM_BACKEND,
  CLEAR_CENTER_NAME,
  DATA_IS_LOADING,
  OPERATOR_CENTER_LIST,
  FETCHING_REFERRAL_FORM,
  INITIATE_WEBSOCKET,
  INTERNET_CONNECTION_STATUS,
  WEBSOCKET_CONNECTION_STATE,
  RETRY_TO_CONNECT_WEBSOCKET_IN_SEC,
  BOT_ERROR,
  ORDER_SCAN_DETAILS,
  SCAN_EXAM_LIST,
  GOT_ERROR_IN_HELP_NOTES,
  DIRECT_CALL_STATIC_DATA,
  CUSTOMER_LIST,
  SCAN_LIST,
  CLIENT_IP
} from "./actionTypes";
import { v4 as uuidv4 } from "uuid";


let initialExamDetails = {
  schedule_datetime: null,
  id: uuidv4(),
  procedure_description: "",
  room_name: "",
  modality: "",
  body_part: "",
  protocol: "",
  purpose_of_study: "",
  laterality: "",
  body_group: "",
  modality_generic: "",
  bodypart_generic: "",
  protocol_generic: "",
  purpose_of_study_generic: "",
  laterality_generic: "",
  bodypart_group_generic: "",
  speciality:"",
  weeks_since_pregnant: "",
  is_pregnancy_flow:false,
  client_ip:null,
};


const GlobalState = {
  SelectedConversationId: null,
  CenterPrefix: null,
  Center: null,
  Caller_id: null,
  initial_time: null,
  ReferralFormPresent: null,
  ConversationLogs: [],
  Error: null,
  showModal: true,
  statusCode: null,
  operatorName: null,
  operatorEmail: null,
  clientMessageFunc: null,
  OperatorWatchlist: "",
  CenterCallStatusList: "",
  CallTakenByOperator: false,
  CenterList: null,
  CallStatusWorkdeskList: null,
  CallStatusCallHistoryList: null,
  CenterListCallHistory: null,
  CallRecord: null,
  SuccessCallStatusList: null,
  CallSource: null,
  Mobile_Number: null,
  ReponseOfCall: false,
  is_Any_Datafetching_Request_InProgress: null,
  showDataLoading: false,
  operatorAssignedCenters: [],
  isReferralFormFetching:null,
  WebSocket: null,
  isInternetDisconnected: null,
  WebSocketConnectionState: 0,
  willTryToReconnectWebSocketInSec: 10,
  selectedBotErrorList:[],
  scanOrderDetails:null,
  scanExamList:[{
...initialExamDetails
  }],
  is_help_notes_got_an_error:false,
  customersList:[],
  directCallStaticInfo:null,
  center_id:null,
  scan_list:[],
  client_ip:null
};

export default function reducer(state = GlobalState, action) {
  switch (action.type) {
    case CONVERSATION_SELECTED: {
      // console.log("CONVERSATION_SELECTED", action.payload);
      const {
        conversation_id,
        caller_id,
        center_name,
        referral_form_status,
        initial_time,
        statusCode,
        center_prefix,
        center_id,
        client_ip   
      } = action.payload;
      return {
        ...state,
        SelectedConversationId: conversation_id,
        Center: center_name,
        Caller_id: caller_id,
        ReferralFormPresent: referral_form_status,
        initial_time: initial_time,
        statusCode: statusCode,
        CenterPrefix: center_prefix,
        center_id:center_id,
        client_ip:client_ip
      };
    }

    case UPDATE_CONVERSATION_LOG:
      const { conversation_log } = action.payload;
      return {
        ...state,
        ConversationLogs: conversation_log,
      };

    case SET_ERROR:
      const { severity, message } = action.payload;
      const messageStack = [];
      if (state.Error != null && state.Error.message != null) {
        messageStack.push(...state.Error.message);
      }
      if (!messageStack.includes(message)) {
        messageStack.push(message);
      }

      return { ...state, Error: { severity: severity, message: messageStack } };

    case CLEAR_ERROR:
      return { ...state, Error: null };
    case STATUS_CODE:
      return { ...state, statusCode: action.payload };

    case USER_NAME:
      const { name, email } = action.payload;
      return { ...state, operatorName: name, operatorEmail: email };

    case CLIENT_MESSAGE_FUNC:
      // console.log("CLIENT MESSAGE ", action.payload);
      const { clientMessageFunc } = action.payload;
      return { ...state, clientMessageFunc: action.payload };

    case OPERATOR_WATCHLIST:
      return { ...state, OperatorWatchlist: action.payload };

    case CALL_TAKEN:
      return { ...state, CallTakenByOperator: action.payload };

    case CENTER_STATUS_LIST:
      return { ...state, CenterCallStatusList: action.payload };

    case CENTER_LIST:
      return { ...state, CenterList: action.payload };
    case STATUS_LIST:
      return { ...state, CallStatusWorkdeskList: action.payload };
    case STATUS_LIST_CALLHISTORY:
      return { ...state, CallStatusCallHistoryList: action.payload };
    case CENTER_LIST_CALLHISTORY:
      return { ...state, CenterListCallHistory: action.payload };
    case CALL_RECORD:
      return { ...state, CallRecord: action.payload };

    case SUCCESS_CALL_STATUS:
      return { ...state, SuccessCallStatusList: action.payload };
    case CNETR_NAME:
      return { ...state, Center: action.payload };
    case CENTER_PREFIX:
      return { ...state, CenterPrefix: action.payload };
    case CALL_SOURCE:
      return {
        ...state,
        CallSource: action.payload,
      };
    case MOBILE_NUMBER:
      return {
        ...state,
        Mobile_Number: action.payload,
      };
    case RESPONSE_OF_CALL:
      return {
        ...state,
        ReponseOfCall: action.payload,
      };
    case CLEAR_CONVERSATION_ID:
      return {
        ...state,
        SelectedConversationId: null,
      };
    case DATA_CAME_FROM_BACKEND:
      return {
        ...state,
        is_Any_Datafetching_Request_InProgress: action.payload,
      };
    case CLEAR_CENTER_NAME:
      return {
        ...state,
        CenterPrefix: null,
        Center: null,
      };

    case DATA_IS_LOADING:
      return {
        ...state,
        showDataLoading: action.payload,
      };
    case OPERATOR_CENTER_LIST:
      return {
        ...state,
        operatorAssignedCenters: action.payload,
      };
    case FETCHING_REFERRAL_FORM:
      return {
        ...state,
        isReferralFormFetching:action.payload
      }
    case INTERNET_CONNECTION_STATUS:
      return {
        ...state,
        isInternetDisconnected: action.payload,
      };
    case INITIATE_WEBSOCKET:
      return {
        ...state,
        WebSocket: action.payload,
      };
    case WEBSOCKET_CONNECTION_STATE:
      return {
        ...state,
        WebSocketConnectionState: action.payload,
      };
    case RETRY_TO_CONNECT_WEBSOCKET_IN_SEC:
      return {
        ...state,
        willTryToReconnectWebSocketInSec: action.payload,
      };
       case BOT_ERROR:
       return {
         ...state,
         selectedBotErrorList:action.payload
       }
       case ORDER_SCAN_DETAILS:
          return {
            ...state,
            scanOrderDetails:action.payload
          }
          case GOT_ERROR_IN_HELP_NOTES:
          return {
            ...state,
            is_help_notes_got_an_error:action.payload
          }

       
       case CUSTOMER_LIST:
       return {
         ...state,
         customersList:action.payload
       }
       case DIRECT_CALL_STATIC_DATA:
       return {
         ...state,
         directCallStaticInfo:action.payload
       }
       case SCAN_LIST:
       return {
         ...state,
         scan_list:action.payload
       }
       case CLIENT_IP:
       return {
         ...state,
         client_ip:action.payload
       }
    default:
      return state;
  }
}
